import { createSlice } from '@reduxjs/toolkit';
import { Config, MainConfig } from 'types/config';

// initial state
const initialState: Config = {
  mainConfig: {} as MainConfig,
  userConfig: { viewRoute: 'Staff', googleAccess: null, notifiedAboutAccounts: false },
};

// ==============================|| SLICE - ALGOLIA ||============================== //

const config = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(state, action) {
      state.mainConfig = { ...state.mainConfig, ...action.payload };
    },
    setUserConfig(state, action) {
      state.userConfig = { ...state.userConfig, ...action.payload };
    },
    setServiceTemplates(state, action) {
      state.mainConfig.serviceTemplates = action.payload;
    },
    setPortalTemplates(state, action) {
      state.mainConfig.portalTemplates = action.payload;
    },
    setDetailsTemplates(state, action) {
      state.mainConfig.detailsTemplates = action.payload;
    },
    setTermsTemplates(state, action) {
      state.mainConfig.termsTemplates = action.payload;
    },
    setEntTypes(state, action) {
      state.mainConfig.entTypes = action.payload;
    },
    setEmailTemplates(state, action) {
      state.mainConfig.emailTemplates = action.payload;
    },
    setEmailTemplateBlasts(state, action) {
      state.mainConfig.emailTemplateBlasts = action.payload;
    },
    setMailLists(state, action) {
      state.mainConfig.mailLists = action.payload;
    },
    setStaffList(state, action) {
      state.mainConfig.staffList = action.payload;
    },
    setError(state, action) {
      state.mainConfig.error = action.payload;
    }
  }
});

export default config.reducer;

export const {
  setConfig,
  setUserConfig,
  setServiceTemplates,
  setPortalTemplates,
  setDetailsTemplates,
  setTermsTemplates,
  setEmailTemplates,
  setEmailTemplateBlasts,
  setMailLists,
  setError,
  setStaffList,
  setEntTypes
} = config.actions;
